import { render, staticRenderFns } from "./MealsSummary.vue?vue&type=template&id=2e23ba46&"
import script from "./MealsSummary.vue?vue&type=script&lang=js&"
export * from "./MealsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports